(function() {
    'use strict';

    angular
        .module('elogbooks.user.finance.sales-invoices')
        .controller('FinanceSalesInvoicesDetailsInfoController', FinanceSalesInvoicesDetailsInfoController);

    FinanceSalesInvoicesDetailsInfoController.$inject = [
        'salesInvoiceResponse'
    ];

    function FinanceSalesInvoicesDetailsInfoController(
        salesInvoiceResponse
    ) {
        var vm = this;
        vm.salesInvoice = salesInvoiceResponse;
    }
})();
